var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithWritingWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 240",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106 188C96 180 88 173 80 166C38 130 16 108 16 74C16 46 37 24 64 24C81 24 95 32 106 45C117 32 131 24 148 24C175 24 196 46 196 74C196 108 174 130 132 166C124 173 116 180 106 188Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 48C84 37 96 32 110 33",
    stroke: "#FFFFFF",
    strokeWidth: 9,
    strokeLinecap: "round",
    opacity: 0.52
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 232,
    y: 151,
    fill: "#FFFFFF",
    fontFamily: "Segoe UI, Arial, Helvetica, sans-serif",
    fontSize: 92,
    fontWeight: 700,
    letterSpacing: -2
  }, "\n    verliebemich\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithWritingWhite);
export default __webpack_public_path__ + "static/media/logo-with-writing-white.70fed6954a0cd6f4eb50a9db102e4cad.svg";
export { ForwardRef as ReactComponent };